import { render } from "./App.vue?vue&type=template&id=fe3a4ea6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fe3a4ea6&lang=css"

import exportComponent from "/root/.jenkins/workspace/dev-mdstar-client/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__